// @flow

import * as React from 'react';

type StepProps = {
  id: string,
  children?: React.Node,
  onClick?: (id: string) => void,
  completed?: boolean,
};

export default class Step extends React.Component<StepProps> {
  render() {
    return this.props.children;
  }
}
Step.displayName = 'StepIndicator.Step';
